// // src/components/JCPasswordModal.tsx
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";

interface JCPasswordModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (password: string) => void;
  isLocked: boolean;
  error?: string;
}

const JCPasswordModal: React.FC<JCPasswordModalProps> = ({
  show,
  onHide,
  onSubmit,
  isLocked,
  error = "",
}) => {
  const [password, setPassword] = useState("");
  const [localError, setLocalError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setPassword("");
      setLocalError("");
      setIsSubmitting(false);
    }
  }, [show]);

  useEffect(() => {
    setLocalError(error);
  }, [error]);

  const handleSubmit = async () => {
    if (!password.trim()) {
      setLocalError("Enter password");
      return;
    }
    
    setIsSubmitting(true);
    try {
      await onSubmit(password);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      header="Password Required"
      visible={show}
      onHide={onHide}
      style={{ width: "400px" }}
      modal
      closable
      footer={
        <>
          <Button 
            label={isSubmitting ? "Submitting..." : "Submit"} 
            icon={isSubmitting ? "pi pi-spinner pi-spin" : "pi pi-check"} 
            onClick={handleSubmit} 
            disabled={isSubmitting}
          />
          <Button
            label="Cancel"
            className="p-button-secondary"
            icon="pi pi-times"
            onClick={onHide}
            disabled={isSubmitting}
          />
        </>
      }
    >
      <div className="p-field">
        <input
          type="password"
          className="p-inputtext w-full"
          value={password}
          placeholder="Enter password"
          onChange={(e) => {
            setPassword(e.target.value);
            if (localError) setLocalError("");
          }}
          onKeyDown={(e) => e.key === "Enter" && !isSubmitting && handleSubmit()}
          autoFocus
          disabled={isSubmitting}
        />
        {localError && <small style={{ color: "red" }}>{localError}</small>}
      </div>

      <small className="p-text-secondary">
        {isLocked
          ? "Enter password to unlock all JC progress"
          : "Enter password to lock all JC progress"}
      </small>
    </Dialog>
  );
};

export default JCPasswordModal;